import React, { useEffect, useState } from 'react';

/* Sur un téléphone où Chrome est en « Version pour ordinateur », la page est rendue en largeur PC (≈ 980 px) et tout devient minuscule,
   y compris dans l'APK (qui utilise Chrome). On le détecte et on explique comment le désactiver. */
function enModeOrdinateur() {
  try {
    const tactile = (navigator.maxTouchPoints || 0) > 0 || (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    const ecran = Math.min(window.screen.width, window.screen.height);
    return tactile && ecran <= 820 && window.innerWidth >= ecran * 1.6;
  } catch (e) { return false; }
}

export default function AlerteModeOrdinateur() {
  const [voir, setVoir] = useState(false);
  useEffect(() => {
    let ferme = false;
    try { ferme = sessionStorage.getItem('ev_mode_pc_ok') === '1'; } catch (e) { /* ignore */ }
    if (!ferme && enModeOrdinateur()) setVoir(true);
  }, []);
  if (!voir) return null;
  const k = Math.max(1, window.innerWidth / Math.min(window.screen.width, window.screen.height)); // grossit le message pour qu'il soit lisible
  return (
    <div style={{ position: 'fixed', left: 0, right: 0, top: 0, zIndex: 100000, background: '#F5B301', color: '#0B1B4D', padding: `${14 * k}px ${16 * k}px`, boxShadow: '0 6px 24px rgba(0,0,0,.25)', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ fontSize: 17 * k, fontWeight: 900, lineHeight: 1.3 }}>📱 Votre téléphone affiche la « version ordinateur »</div>
      <div style={{ fontSize: 15 * k, lineHeight: 1.45, marginTop: 6 * k }}>
        Tout est en tout petit. Pour l'affichage de l'application :<br />
        1. Ouvrez <b>Chrome</b> → menu <b>⋮</b> (en haut à droite)<br />
        2. <b>Décochez « Version pour ordinateur »</b><br />
        3. Fermez puis rouvrez l'appli EVOLINK.
      </div>
      <button onClick={() => { setVoir(false); try { sessionStorage.setItem('ev_mode_pc_ok', '1'); } catch (e) { /* ignore */ } }}
        style={{ marginTop: 10 * k, fontSize: 15 * k, fontWeight: 900, padding: `${8 * k}px ${16 * k}px`, borderRadius: 10 * k, border: 0, background: '#0B1B4D', color: '#fff' }}>OK</button>
    </div>
  );
}
